import { TRAIT_CLASS_RANGES, Trait } from "./consts";

export type CompetencyStatus = "highly-prioritized" | "prioritized" | "neutral";

export interface TraitCompetency {
  trait: string;
  status: CompetencyStatus;
  watchOut: boolean;
}

export interface CompetencyGroup {
  level: 0 | 1 | 2;
  items: TraitCompetency[];
  prioritized: number;
  total: number;
}

// Builds the Must-Have (2) / Nice-to-Have (1) / Neutral (0) competency groups for a candidate,
// classifying each trait against its class range and flagging "watch out" cases.
// Shared by the Evaluation Report overview scorecards and the Analysis tab sidebar.
export function getCompetencyGroups(traitPriorities: { [trait: string]: 0 | 1 | 2 }, traitScores: { [trait: string]: number }): CompetencyGroup[] {
  const levels: (0 | 1 | 2)[] = [2, 1, 0];

  return levels.map((level) => {
    const traits = Object.keys(traitPriorities).filter((t) => traitPriorities[t] === level);

    const items: TraitCompetency[] = traits.map((trait) => {
      const range = TRAIT_CLASS_RANGES[trait as Trait];
      const score = traitScores[trait] ?? 0;

      let status: CompetencyStatus;
      if (score >= range.high) {
        status = "highly-prioritized";
      } else if (score >= range.low) {
        status = "prioritized";
      } else {
        status = "neutral";
      }

      const watchOut = (level === 0 && status === "highly-prioritized") || (level === 2 && status === "neutral");

      return { trait, status, watchOut };
    });

    const prioritized = items.filter((i) => i.status !== "neutral").length;
    return { level, items, prioritized, total: items.length };
  });
}
